import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installGlobalErrorHandlers } from './utils/logger';
import { i18nReady } from './i18n';
import { initAnalytics } from './utils/analytics';

// Uncaught errors and unhandled rejections are reported to the backend in production
installGlobalErrorHandlers();
// Google Analytics loads only for visitors who accepted it on the cookie banner
initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// Render once the saved language is loaded, so the first screen is not English for a moment
i18nReady.then(() => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
